export default "__VITE_ASSET__tWkqFrlJ__"